var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0797 11.6133H8.50586C7.84679 11.6133 7.3125 12.1476 7.3125 12.8066V23.9199C7.3125 24.579 7.84679 25.1133 8.50586 25.1133H27.0797C27.7388 25.1133 28.2731 24.579 28.2731 23.9199V12.8066C28.2731 12.1476 27.7388 11.6133 27.0797 11.6133Z",
    fill: "#F9F9F9",
    stroke: "#F8F8F8",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9466 15.8355L15.1162 20.9385H16.4447L17.2752 15.8355H15.9466ZM13.9985 15.8355L12.7319 19.3453L12.5821 18.5895L12.5822 18.5897L12.5491 18.4203C12.3959 18.09 12.0408 17.4621 11.3704 16.9262C11.1828 16.7767 10.9853 16.64 10.7793 16.5172L11.9305 20.9385H13.3146L15.4284 15.8355H13.9985ZM19.1833 17.2522C19.1833 16.6752 20.4772 16.7494 21.0457 17.0626L21.2353 15.9666C21.2353 15.9666 20.6502 15.7441 20.0403 15.7441C19.381 15.7441 17.8154 16.0325 17.8154 17.4335C17.8154 18.7519 19.653 18.7683 19.653 19.4606C19.653 20.1528 18.0049 20.0291 17.461 19.5924L17.2633 20.738C17.2633 20.738 17.8565 21.0263 18.7631 21.0263C19.6695 21.0263 21.0374 20.5567 21.0374 19.2793C21.0374 17.9525 19.1833 17.829 19.1833 17.2522ZM24.6045 15.8355H23.5364C23.0432 15.8355 22.9231 16.2158 22.9231 16.2158L20.9419 20.9385H22.3266L22.6036 20.1805H24.2925L24.4483 20.9385H25.6681L24.6045 15.8355ZM22.9864 19.1333L23.6845 17.2237L24.0772 19.1333H22.9864Z",
    fill: "#005BAC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1531 16.3155C12.1531 16.3155 12.0982 15.855 11.5111 15.855H9.37825L9.35327 15.9415C9.35327 15.9415 10.3785 16.1505 11.362 16.9335C12.302 17.6819 12.6086 18.6147 12.6086 18.6147L12.1531 16.3155Z",
    fill: "#F6AC1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.e1866d639df369b156cd16dbcea537a7.svg";
export { ForwardRef as ReactComponent };